import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#FDFBF7]">
        <Loader2 className="w-8 h-8 animate-spin text-[#5B6E5B]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
